

























































import {ProjectStatus} from '../model/enum/project-status.enum';
import Component from "vue-class-component";
import Vue from "vue";
import {ProjectMetaData} from "../model/interface/project.interface";
import {Prop} from "vue-property-decorator";
import ProjectEditComponent from "./project-edit.vue";
import ProjectWhitelistComponent from "./whitelist.vue";
import {ProjectService} from "../services/project.service";
import {MessageBus} from "../services/messageBus";
import {AlertType} from "../model/enum/alert.enum";
import ProjectMigrationComponent from "./project-migration.vue";

@Component({
  components: {
    ProjectEditComponent,
    ProjectWhitelistComponent,
    ProjectMigrationComponent
  }
})
export default class ProjectCardComponent extends Vue {
  @Prop(Object) project!: ProjectMetaData;
  private showEditDialog: number = 0;
  private showWhitelistDialog: number = 0;
  private showMigrationDialog: number = 0;
  private openDropProjectDialog: boolean = false;

  private showEditDialogAction() {
    this.showEditDialog++;
  }

  private showWhitelistDialogAction() {
    this.showWhitelistDialog++;
  }

  private showMigrationDialogAction() {
    this.showMigrationDialog++;
  }

  private async removeProject() {
    if (!this.project) {
      return;
    }
    try {
      const status = await ProjectService.deleteProject(this.project.id);
      if (status === this.project.id) {
        MessageBus.$emit(AlertType[AlertType.success], `Project ${this.project.id} deleted successful!`);
        this.project = null;
      }
    } catch (e) {
      MessageBus.$emit(AlertType[AlertType.error], 'Error during Project deletion! ' + e);
    }
  }

  private routeToGenerator() {
    this.$router.push(`/generator/${this.project.id}`);
  }

  private openDropProjectDialogAction() {
    this.openDropProjectDialog = true;
  }

  private statusClass(projectstatus: ProjectStatus) { //more sophisticated validation possible
    switch (projectstatus) {
      case ProjectStatus.CREATED:
        return 'wimpub_project_status_created';
      case ProjectStatus.OK:
        return 'wimpub_project_status_ok';
      case ProjectStatus.FAILED:
        return 'wimpub_project_status_failed';
      case ProjectStatus.MIGRATING:
        return 'wimpub_project_status_migrating';
    }
    return "";
  }

  get isMigrating() {
    return this.project.status === ProjectStatus.MIGRATING;
  }
}
